import { useLanguage } from '@shared/contexts/LanguageContext';

export default function LiveBadge({ type = 'live', size = 'sm', className = '' }) {
  const { t } = useLanguage();
  const CONFIGS = {
    live: { base: 'bg-green-50 text-green-600', dot: 'bg-green-400', label: t('live-badge.live'), pulse: true },
    settled: { base: 'bg-purple-50 text-purple-500', dot: null, label: t('live-badge.settled'), pulse: false },
    ended: { base: 'bg-[#F9F6F1] text-[#6E625B]', dot: null, label: t('live-badge.ended'), pulse: false },
    upcoming: { base: 'bg-blue-50 text-blue-500', dot: null, label: t('live-badge.upcoming'), pulse: false },
  };
  const cfg = CONFIGS[type] ?? CONFIGS.live;
  const sizeClass = size === 'md' ? 'text-sm font-semibold px-3 py-1' : 'text-xs font-semibold px-2 py-0.5';

  return (
    <span className={`inline-flex items-center gap-1 rounded-full ${cfg.base} ${sizeClass} ${className}`}>
      {cfg.dot && (
        <span className={`w-1.5 h-1.5 rounded-full inline-block ${cfg.dot} ${cfg.pulse ? 'animate-pulse' : ''}`} />
      )}
      {cfg.label}
    </span>
  );
}
